import React, { useState, useEffect } from 'react';
import icons from '../../utils/icons.json';
import { capitalize } from '../../utils/functions';
import { useNavigate } from 'react-router-dom';

const Topsellingcard = ({ product, key }) => {
    const navigate = useNavigate()

    const imgsrc = product.src[0]

    function viewProduct() {
        navigate('/product/' + product.itemURL, {
            state: { product: product }
        });
    }

    return (
        <div className='topsellingcard' onClick={() => viewProduct()} key={key}>
            <img src={imgsrc} className='topsellingcardimage' />
            {imgsrc == null && <span dangerouslySetInnerHTML={{ __html: icons.sm_spinner }}></span>}
            <div className='topsellingcardright'>
                <h3>{product.item_name.substring(0, 20).toUpperCase()}..</h3>
                {product.promotion_price > 0 ?
                    <div>KES {product.promotion_price} <div className='discountprice'>{parseFloat(product.price)?.toFixed(2)}</div></div> :
                    <div>KES {parseFloat(product.price)?.toFixed(2)}</div>
                }
            </div>
        </div>
    )
}

export default Topsellingcard